import { Link } from 'react-router-dom';
import { voiceActorHighlights } from '@/mocks/voiceActors';

export default function VoiceActorSection() {
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
              <i className="ri-mic-2-line" aria-hidden="true"></i>
              声优阵容
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-900 md:text-3xl">
              守护甜心动漫声优表精选
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
              从主角亚梦到偶像歌呗，每位角色的声音背后，都是一位用心演绎的配音演员。
            </p>
          </div>
          <Link
            to="/voice-actors"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-500 px-5 py-2.5 text-sm font-semibold text-accent-600 transition-colors hover:bg-accent-500 hover:text-background-50"
          >
            完整声优表
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {voiceActorHighlights.map((va) => (
            <article
              key={va.name}
              className="flex items-center gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-4"
            >
              <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-full">
                <img
                  src={va.image}
                  alt={`配音演员 ${va.name} 插画`}
                  className="h-full w-full object-cover"
                  loading="lazy"
                />
              </div>
              <div>
                <span className="inline-flex rounded-full bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-700">
                  {va.tag}
                </span>
                <h3 className="mt-1.5 font-heading text-base font-bold text-foreground-900">{va.name}</h3>
                <p className="mt-0.5 text-sm text-primary-600">配音：{va.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}